import styled from 'styled-components'
import {
  chalkboard600,
  cream100,
  cream200,
  cream600,
  greyLight1,
  navy900,
  white,
} from '@edulastic/colors'

export const ACTION_HUB_FAB_COLOR = '#292929'
export const ACTION_HUB_BORDER_COLOR = '#D9D9D9'

export const ActionHubRoot = styled.div`
  position: fixed;
  bottom: 24px;
  right: 24px;
  /* z-index 999: below than .ant-modal-wrap (1003 in index.css) so View-as-Student preview hides Action Hub like the SF bubble. */
  z-index: 999;
  display: ${({ $hidden }) => ($hidden ? 'none' : 'block')};
`

export const ActionHubFab = styled.button`
  width: 56px;
  height: 56px;
  border-radius: 50%;
  border: ${({ $expanded }) =>
    $expanded ? `1px solid ${ACTION_HUB_BORDER_COLOR}` : 'none'};
  background: ${({ $expanded }) =>
    $expanded ? cream100 : ACTION_HUB_FAB_COLOR};
  color: ${({ $expanded }) => ($expanded ? navy900 : white)};
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  transition: transform 0.2s ease, background-color 0.2s ease,
    border-color 0.2s ease;

  &:hover,
  &:focus-visible {
    transform: scale(1.05);
    outline: 2px solid
      ${({ $expanded }) => ($expanded ? navy900 : ACTION_HUB_FAB_COLOR)};
    outline-offset: 2px;
  }
`

export const ActionHubFabIconWrap = styled.span`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
`

export const ActionHubFabIconLayer = styled.span`
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: opacity 0.22s ease, transform 0.22s ease;
  opacity: ${({ $visible }) => ($visible ? 1 : 0)};
  transform: ${({ $visible }) =>
    $visible ? 'scale(1) rotate(0deg)' : 'scale(0.5) rotate(-90deg)'};
  pointer-events: none;
`

export const ActionHubMenu = styled.ul`
  list-style: none;
  margin: 0;
  padding: 0;
  display: inline-grid;
  grid-template-columns: 1fr;
  gap: 8px;
  position: absolute;
  right: 0;
  bottom: 67px;
  opacity: ${({ $expanded }) => ($expanded ? 1 : 0)};
  transform: ${({ $expanded }) =>
    $expanded ? 'translateY(0) scale(1)' : 'translateY(10px) scale(0.96)'};
  transform-origin: bottom right;
  transition: ${({ $joyrideActive }) =>
    $joyrideActive
      ? 'none'
      : 'opacity 0.22s ease, transform 0.22s ease, visibility 0.22s ease'};
  pointer-events: ${({ $expanded }) => ($expanded ? 'auto' : 'none')};
  visibility: ${({ $expanded }) => ($expanded ? 'visible' : 'hidden')};
`

export const ActionHubMenuItem = styled.li`
  margin: 0;
`

export const ActionHubMenuButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  box-sizing: border-box;
  padding: 10px 36px;
  border: 1px solid
    ${({ $disabled }) => ($disabled ? greyLight1 : ACTION_HUB_BORDER_COLOR)};
  border-radius: 38px;
  background: ${({ $disabled }) => ($disabled ? cream200 : cream100)};
  box-shadow: ${({ $disabled }) =>
    $disabled ? 'none' : '0px 0px 17px rgba(0, 0, 0, 0.14)'};
  color: ${({ $disabled }) => ($disabled ? cream600 : navy900)};
  font-size: 15px;
  font-weight: 600;
  line-height: 20px;
  cursor: ${({ $disabled }) => ($disabled ? 'not-allowed' : 'pointer')};
  opacity: 1;
  text-align: center;
  white-space: nowrap;
  opacity: ${({ $disabled }) => ($disabled ? 0.5 : 1)};

  &:disabled {
    opacity: 1;
  }

  &:disabled {
    opacity: 1;
  }

  &:disabled {
    opacity: 1;
  }

  &:hover,
  &:focus-visible,
  &:active {
    background: ${({ $disabled }) => ($disabled ? cream200 : chalkboard600)};
    color: ${({ $disabled }) => ($disabled ? cream600 : white)};
    outline: none;
  }
`
